<template>
    <div>
        <b-card-actions action-collapse title="Manage Property Group">
            <validation-observer ref="SubscriberRules" v-slot="{ validate }">
                <b-form @submit.prevent="onSubmit(validate)">
                <b-row>
                    <b-col cols="12" md="6" class="mb-md-0 mb-2">
                    <b-form-group label="Title">
                        <validation-provider
                        name="title"
                        rules="required"
                        v-slot="{ errors }"
                        >
                        <b-form-input
                            v-model="title"
                            placeholder="Enter title"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    </b-col>

                    <b-col cols="12">
                    <b-button
                        variant="primary"
                        type="submit"
                    >
                        Submit
                    </b-button>
                    </b-col>
                </b-row>
                </b-form>
            </validation-observer>
        </b-card-actions>

        <b-card-actions action-collapse title="Property Selected">
            <b-table
                striped
                hover
                responsive
                :per-page="perpageSelected"
                :current-page="currentPageSelected"
                :items="propertiesSelected"
                :fields="propertyFields"
                show-empty
                empty-text="No matching records found"   
            >
                <template #cell(id)="data">
                    <feather-icon @click="removeProperty(data.item.id)" icon="MinusIcon" />
                </template>
                <template #cell(units)="data">
                    {{ data.item.units }} 
                    {{ data.item.address_no }}
                </template>
                <template #cell(property)="data">
                    <div class="list-property">
                        <a to="{ name: 'property-create'}">{{ data.item.property_code }}</a>
                        <b-badge v-if="data.item.action_id == 1" variant="light-secondary">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.action_id == 2" variant="light-info">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.action_id == 3" variant="light-success">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.action_id == 4" variant="light-warning">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.status_id == 1" variant="light-success">
                            {{ data.item.status_code }}
                        </b-badge>
                        <b-badge v-else variant="light-secondary">
                            {{ data.item.status_code }}
                        </b-badge>
                        <b-badge  variant="light-primary"   @click="doCopy(data.item.place_name,data.item.property_code)">
                            <feather-icon
                                icon="CopyIcon"
                                size="24"
                            />
                        </b-badge>
                        <br />
                        {{ data.item.place_name[currentLocale] }}<br /><br />
                        {{ data.item.comment }}
                    </div>
                </template>
                <template #cell(image)="data">
                    <b-button variant="flat-primary" class="pb0" :to="{ name: 'property-upload', params: { id: data.item.id } }">
                        <b-img   
                            class="img_property" 
                            v-if="data.item.property_images[0] "
                            :src="data.item.property_images[0].fullfilepath"         
                        />
                        <b-img   class="img_property" v-else
                            :src="'http://128.199.95.64:81/assets/images/default/property/picture.png'"
                        />
                    </b-button>
                </template>
                <template #cell(owner)="row">
                    <b-form-checkbox
                        v-model="row.detailsShowing"
                        plain
                        class="vs-checkbox-con"
                        @change="row.toggleDetails"
                    >
                        <span class="vs-label">{{ row.item.owner_firstname  }} {{ row.item.owner_lastname  }}</span>
                    </b-form-checkbox>
                </template>
                <template #row-details="row">
                    <b-card>
                        <b-row class="mb-2">
                            <b-col md="4" class="mb-1" >
                                <strong>Full Name : </strong><router-link :to="{ name: 'clients-edit', params: { id: row.item.owner_id } }" target="_blank" >{{ row.item.owner_firstname  }} {{ row.item.owner_lastname  }}</router-link>
                            </b-col>
                        
                            <b-col md="4" class="mb-1" >
                                <strong>Email : </strong> <a :href="'mailto:'+row.item.owner_email">{{ row.item.owner_email  }} </a>
                            </b-col>

                            <b-col md="4" class="mb-1" >
                                <strong>Phone : </strong><a :href="'tel:'+row.item.owner_phone">{{ row.item.owner_phone  }} </a>
                            </b-col>
                        </b-row>

                        <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="row.toggleDetails"
                        >
                            Hide Details
                        </b-button>
                    </b-card>
                </template>
                <template #cell(price_rent)="data">
                    {{ data.item.rent_price | getcomma }}
                </template>
                <template #cell(price_sale)="data">
                    {{ data.item.sale_price | getcomma }}
                </template>
            </b-table>
            <b-pagination
                v-if="totalRowSelected > 0"
                v-model="currentPageSelected"
                :total-rows="totalRowSelected"
                :per-page="perpageSelected"
                align="center"
                size="sm"
                class="my-0"
            />
        </b-card-actions>

        <b-card-actions action-collapse title="Property List">
            <!-- <div class="mt-1 mb-1">
                <b-form-checkbox
                    v-model="statusId"
                    value="0"
                    @input="changeStatus"
                    class="custom-control-primary mr-2"
                >
                    Avl
                </b-form-checkbox>
            </div> -->
            <b-table
                striped
                hover
                responsive
                :items="properties"
                :fields="propertyFields"
                show-empty
                empty-text="No matching records found"
            >
                <template slot="top-row" slot-scope="{ fields }">
                    <td v-for="field in fields" :key="field.key">
                        <b-form-input
                            v-if="field.key == 'units'"
                            v-model="unit"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'floors'"
                            v-model="floor"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'types'"
                            v-model="types"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'buildiing'"
                            v-model="building"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'bedroom'"
                            v-model="bedroom"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'sqm'"
                            v-model="sqm"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'price_rent'"
                            v-model="price_rent"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'price_sale'"
                            v-model="price_sale"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'property'"
                            v-model="propertyfilter"
                            :placeholder="field.label"
                        />
                        <b-form-input
                            v-if="field.key == 'owner'"
                            v-model="ownerfilter"
                            :placeholder="field.label"
                        />
                    </td>
                </template>
                <template #cell(id)="data">
                    <feather-icon @click="selectProperty(data.item)" icon="PlusIcon" />
                </template>
                <template #cell(units)="data">
                    {{ data.item.units }} 
                    {{ data.item.address_no }}
                </template>
                <template #cell(property)="data">
                    <div class="list-property">
                        <router-link :to="{ name: 'property-edit', params: { id: data.item.id } }" >{{ data.item.property_code }}</router-link>
                        <b-badge v-if="data.item.action_id == 1" variant="light-secondary">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.action_id == 2" variant="light-info">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.action_id == 3" variant="light-success">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.action_id == 4" variant="light-warning">
                            {{ data.item.action_name }}
                        </b-badge>
                        <b-badge v-if="data.item.status_id == 1" variant="light-success">
                            {{ data.item.status_code }}
                        </b-badge>
                        <b-badge v-else variant="light-secondary">
                            {{ data.item.status_code }}
                        </b-badge>
                        <br />
                        {{ data.item.place_name[currentLocale] }}
                        <br />
                        <br />
                        {{ data.item.comment }}
                    </div>  
                </template>
                <template #cell(image)="data">
                    <b-button variant="flat-primary" class="pb0" :to="{ name: 'property-upload', params: { id: data.item.id } }">
                        <b-img   
                            class="img_property" 
                            v-if="data.item.property_images[0] "
                            :src="data.item.property_images[0].fullfilepath"
                            fluid
                        />
                        <b-img   class="img_property" v-else
                            :src="'http://128.199.95.64:81/assets/images/default/property/picture.png'"
                            fluid
                        />
                    </b-button>
                </template>
                <template #cell(owner)="row">
                    <b-form-checkbox
                        v-model="row.detailsShowing"
                        plain
                        class="vs-checkbox-con"
                        @change="row.toggleDetails"
                    >
                        <span class="vs-label">{{ row.item.owner_firstname  }} {{ row.item.owner_lastname  }}</span>
                    </b-form-checkbox>
                </template>
                <template #row-details="row">
                    <b-card>
                        <b-row class="mb-2">
                            <b-col md="4" class="mb-1" >
                                <strong>Full Name : </strong><router-link :to="{ name: 'clients-edit', params: { id: row.item.owner_id } }" target="_blank" >{{ row.item.owner_firstname  }} {{ row.item.owner_lastname  }}</router-link>
                            </b-col>
                        
                            <b-col md="4" class="mb-1" >
                                <strong>Email : </strong> <a :href="'mailto:'+row.item.owner_email">{{ row.item.owner_email  }} </a>
                            </b-col>

                            <b-col md="4" class="mb-1" >
                                <strong>Phone : </strong><a :href="'tel:'+row.item.owner_phone">{{ row.item.owner_phone  }} </a>
                            </b-col>
                        </b-row>
                        <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="row.toggleDetails"
                        >
                            Hide Details
                        </b-button>
                    </b-card>
                </template>
                <template #cell(price_rent)="data">
                    {{ data.item.rent_price | getcomma }}
                </template>
                <template #cell(price_sale)="data">
                    {{ data.item.sale_price | getcomma }}
                </template>
            </b-table>
            <b-pagination
                v-if="totalRow > 0"
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perpage"
                align="center"
                size="sm"
                class="my-0"
            />
        </b-card-actions>
    </div>
</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BForm,
  BBadge, BDropdown, BDropdownItem, BPagination,BFormCheckbox,BImg,BCardHeader,BCardBody,BOverlay
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import Button from '../../components/button/Button.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations';
import store from '@/store';
import crmStoreModule from '../crmStoreModule';
import axios from '@axios';
import router from '@/router'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'

export default {
    components:{
        ValidationProvider, 
        ValidationObserver,
        crmStoreModule,
        BCard, BRow, BCol, BFormGroup , BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
        BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BImg,
        vSelect,
        BCardHeader, BCardBody, BOverlay,
        BCardActions,
        Button,
        BForm,
    },
    data() {
        return {
            id: router.currentRoute.params.id,
            perpageSelected: 5,
            currentPageSelected: 1,
            propertiesSelected: [],
            totalRowSelected: 0,
            propertyFields: [
                {
                    key: 'id', label: '',
                },
                {
                    key: 'image', label: 'Image', tdClass:'width-300 p-0',
                },
                {
                    key: 'property', label: 'Property Code',
                },
                {
                    key: 'owner', label: 'Owner',
                },
                {
                    key: 'units', label: 'units',
                },
                {
                    key: 'floors', label: 'Floor',
                },
                {
                    key: 'type_name', label: 'Type',
                },
                {
                    key: 'buildiing', label: 'Building',
                },
                {
                    key: 'bedroom', label: 'Bd',
                },
                {
                    key: 'sqm', label: 'Sqm',
                },
                {
                    key: 'price_rent', label: 'Rent',
                },
                {
                    key: 'price_sale', label: 'Sale',
                },
                {
                    key: 'exp', label: 'Exp/Avail Date  ',
                },
                {
                    key: 'rating', label: 'Rating',
                },
                {
                    key: 'furniture_name', label: 'Furniture',
                },
                {
                    key: 'bts_name', label: 'BTS',
                },
                {
                    key: 'mrt_name', label: 'MRT',
                },
                {
                    key: 'zone_name', label: 'Zone',
                },
                {
                    key: 'id', label: 'ID',
                },
            ],
            statusId: 1,
            propertyfilter: null,
            ownerfilter: null,
            unit: null,
            floor: null,
            building: null,
            bedroom: null,
            sqm: null,
            price_rent: null,
            price_sale: null,
            properties: [],
            totalRow: 0,
            perpage: 15,
            currentPage: 1,
            title: '',
            created_by: '',
            updated_by: '',
        }
    },
    computed: {
        currentLocale() {
            return  this.$i18n.locale;
        },
    },
    directives: {
        Ripple,
    },
    methods: {
        // changeStatus() {
        //     this.properties = []
        //     this.currentPage = 1
        //     this.getPropertyData();
        // },
        selectProperty(item) {
            const index =  this.propertiesSelected.findIndex(p => p.id === item.id);
            
            if(index <  0){
                this.propertiesSelected.push(item);
                this.totalRowSelected = this.propertiesSelected.length;
            }
        },
        removeProperty(id) {
            this.propertiesSelected = this.propertiesSelected.filter(v => v.id  != id);
            this.totalRowSelected = this.propertiesSelected.length;
        },
        async getPropertyData() {
            try {
                const offset =  this.perpage * (this.currentPage - 1);
            
                const body = {
                    perpage: this.perpage,
                    offset: offset,
                    is_active: 1,
                    propertyfilter: this.propertyfilter,
                    ownerfilter: this.ownerfilter,
                    unit: this.unit,
                    sqm: this.sqm,
                    building: this.building,
                    bedroom: this.bedroom,
                    floor: this.floor,
                    price_rent: this.price_rent,
                    price_sale: this.price_sale,
                }

                const response = await axios.post('cache-master/v1/property-filter', body);
                if(response?.data?.success){
                    this.properties = response?.data?.data
                    this.totalRow = response?.data?.total
                }
            } catch(error) {
                console.log('error fetching property data: ', error || 'Cannot fetching property data')
            }
        },
        async onSubmit(validate) {
            const isValid = await validate();
            const userData = JSON.parse(localStorage.getItem('userData'))

            if (isValid) {
                const response = await axios.post('/crm/v1/property-group/add', {
                    title: this.title,
                    created_by: userData.id,
                    properties: this.propertiesSelected
                });

                if(!response.data.success){
                    this.makeToast('danger','Error 403',res.data.message);
                } else {
                    this.$router.push('/crm/property', () => {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Done`,
                                icon: 'CoffeeIcon',
                                variant: 'success',
                                text: `You have successfully created.`,
                            },
                        })
                    });
                }
            }
        },
    },
    created() {
        this.getPropertyData();
    },
    watch: {
        currentPage(value) {
            this.properties = [];
            this.currentPage = value;
            this.getPropertyData();
        },
        propertyfilter(value) {
            this.properties = [];
            this.currentPage = 1;
            this.propertyfilter = value;
            this.getPropertyData();
        },
        ownerfilter(value){
            this.properties = [];
            this.currentPage = 1
            this.ownerfilter = value;
            this.getPropertyData();
        },
        unit(value){
            this.properties = [];
            this.currentPage = 1
            this.unit = value;
            this.getPropertyData();
        },
        sqm(value){
            this.properties = [];
            this.currentPage = 1
            this.sqm = value;
            this.getPropertyData();
        },
        building(value){
            this.properties = [];
            this.building = value;
            this.currentPage = 1
            this.getPropertyData();
        },
        bedroom(value){
            this.properties = [];
            this.currentPage = 1
            this.bedroom = value;
            this.getPropertyData();
        },
        floor(value){
            this.properties = [];
            this.floor = value;
            this.currentPage = 1
            this.getPropertyData();
        },
        price_rent(value){
            this.properties = [];
            this.currentPage = 1
            this.price_rent = value;
            this.getPropertyData();
        },
        price_sale(value){
            this.properties = [];
            this.currentPage = 1
            this.price_sale = value;
            this.getPropertyData();
        },
    },
    filters: {
        getcomma: function(text) {
            if(!text){
                return ''
            }

            var nStr = text;
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;

            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }

            return x1 ;
        },
    },
    setup() {
        const CRM_APP_STORE_MODULE_NAME = 'app-crm';
        if (!store.hasModule(CRM_APP_STORE_MODULE_NAME)) store.registerModule(CRM_APP_STORE_MODULE_NAME, crmStoreModule);
        
        onUnmounted(() => {
            if (store.hasModule(CRM_APP_STORE_MODULE_NAME)) store.unregisterModule(CRM_APP_STORE_MODULE_NAME)
        })

    }
}
</script>